// extracted by mini-css-extract-plugin
module.exports = {"copied":"ShareModal_copied__PZ2zn","modal":"ShareModal_modal__Vx4k7"};